import { apiClientGeral } from '@/plugins/axios'

export default {
  getRamaisPermitidos() {
    return apiClientGeral().get('/monitor/ramaisPermitidos')
  },
}
